module.exports = __webpack_public_path__ + "static/media/chef and cook.dc444e62.png";